// Percentage points: 60 means 60%, never 0.60.
export const percentagePrecision = (config = {}) =>
  Number.isInteger(config.decimal_places) &&
  config.decimal_places >= 0 &&
  config.decimal_places <= 20
    ? config.decimal_places
    : 0;
export const percentageValueError = (value, config = {}) => {
  if (value === null || value === undefined || value === '') return '';
  if (
    !['number', 'string'].includes(typeof value) ||
    (typeof value === 'string' && !value.trim())
  )
    return 'Enter a percentage between 0 and 100.';
  const number = Number(value);
  if (!Number.isFinite(number) || number < 0 || number > 100)
    return 'Enter a percentage between 0 and 100.';
  const [mantissa, exponent = '0'] = String(number).split('e');
  const places = Math.max(
    0,
    (mantissa.split('.')[1]?.length || 0) - Number(exponent)
  );
  const precision = percentagePrecision(config);
  return places > precision
    ? 'Use at most ' + precision + ' decimal places.'
    : '';
};
export const validatePercentageFields = (cards = [], values = {}) => {
  const errors = {};
  for (const card of cards)
    for (const item of card.items || []) {
      if (
        item.field?.field_type !== 'number' ||
        item.field.config?.format !== 'percentage'
      )
        continue;
      const error = percentageValueError(
        values[item.field_id],
        item.field.config
      );
      if (error) errors[item.field_id] = error;
    }
  return errors;
};
export const formatPercentageValue = (value, config, locale) => {
  if (value < 0 || value > 100) return 'Invalid percentage';
  const precision = percentagePrecision(config);
  // Only the display adapter divides by 100 for Intl's ratio-based API.
  return new Intl.NumberFormat(locale, {
    style: 'percent',
    useGrouping: false,
    minimumFractionDigits: precision,
    maximumFractionDigits: precision
  }).format(value / 100);
};
